<template>
  <div style="min-width: 1280px">
    <site-header
      :class="{ sticky: $route.path !== '/site/product' }"
    ></site-header>
    <router-view></router-view>
    <site-footer></site-footer>

    <div
      style="
        gap: 20px;
        padding: 18px 6px;
        background: #ffffff;
        box-shadow: 0px 0px 16px 0px rgba(82, 89, 103, 0.2);
        border-radius: 8px;
        position: fixed;
        top: 320px;
        right: 20px;
        flex-direction: column;
      "
      class="center"
    >
      <div
        v-for="item in arr"
        :key="item.name"
        class="center help-item"
        @click="help(item.name)"
      >
        <img :src="item.icon" alt="" style="width: 26px; height: 26px" />
        <span style="font-size: 12px; color: #525967; line-height: 17px">{{
          item.name
        }}</span>

        <div class="help-box" v-if="item.name === '电话咨询'">
          <span style="font-size: 14px; color: #333333; line-height: 20px"
            >免费咨询热线</span
          >
          <span
            style="
              font-weight: 500;
              font-size: 18px;
              color: #2e98fe;
              line-height: 26px;
            "
            >021-20787301</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SiteHeader from "./SiteHeader.vue";
import SiteFooter from "./SiteFooter.vue";
export default {
  name: "Site",
  components: {
    SiteHeader,
    SiteFooter,
  },
  data() {
    return {
      arr: [
        {
          name: "客服咨询",
          icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/12/05/客服-101942053.png",
        },
        {
          name: "电话咨询",
          icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/12/05/电话-101942055.png",
        },
        {
          name: "微信咨询",
          icon: "https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/12/05/微信-101942053.png",
        },
      ],
    };
  },
  created() {
    console.log(this.$route.path);
  },
  methods: {
    help(name) {
      console.log(name);
      if (name === "客服咨询" || name === "微信咨询") {
        window.open(
          "https://work.weixin.qq.com/kfid/kfc3f3dd6ad984d2758",
          "_blank"
        );
      }
    },
  },
};
</script>

<style lang="less" scoped>
.sticky {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
}

.help-item {
  gap: 6px;
  flex-direction: column;
  cursor: pointer;
  user-select: none;
  position: relative;
  .help-box {
    position: absolute;
    top: -16px;
    right: 40px;
    width: 180px;
    height: 86px;
    background: #ffffff;
    box-shadow: 0px 0px 16px 0px rgba(82, 89, 103, 0.2);
    border-radius: 8px;
    opacity: 0;
    transition: all 0.3s ease-in-out;
    padding: 19px 24px;
    display: flex;
    flex-direction: column;
    gap: 2px;
    user-select: text;
  }
  &:hover {
    .help-box {
      opacity: 1;
      right: 60px;
    }
  }
}
</style>